import { Button } from "./shadcn/button";

export function UAEPassButton({
  onClick,
  text,
}: {
  onClick: () => void;
  text: string;
}) {
  return (
    <Button
      type="button"
      variant="outline"
      onClick={onClick}
      className="w-full mt-4 group border border-input shadow-xs bg-white hover:bg-white text-black"
    >
      <img src="/uaepass-logo.svg" alt="Sign in with UAE Pass" />
      {text}
    </Button>
  );
}
